// extracted by mini-css-extract-plugin
module.exports = {"label":"_27492da8","tabs":"_e1473a2a","border":"_845f7f02"};